export const MAX_LESSON_TITLE_LENGTH = 255
export const MAX_LESSON_DESCRIPTION_LENGTH = 5000
export const MIN_LESSON_DURATION = 15
export const MAX_LESSON_DURATION = 480
export const MAX_OBJECTIVES_COUNT = 10

export const LESSON_ERRORS = {
  NOT_FOUND: 'Leçon non trouvée',
  ALREADY_DELETED: 'Leçon déjà supprimée',
  INVALID_CHAPTER: 'Chapitre invalide',
  DUPLICATE_TITLE: 'Une leçon avec ce titre existe déjà dans ce chapitre',
  INVALID_STATUS: 'Statut de leçon invalide',
  INVALID_TYPE: 'Type de leçon invalide',
  INVALID_DURATION: 'Durée invalide',
  INVALID_DATE_RANGE: 'La date de fin doit être postérieure à la date de début',
  CHAPTER_NOT_FOUND: 'Chapitre non trouvé',
  CREATION_FAILED: 'Erreur lors de la création de la leçon',
  UPDATE_FAILED: 'Erreur lors de la mise à jour de la leçon',
  DELETE_FAILED: 'Erreur lors de la suppression de la leçon',
} as const

export const LESSON_SUCCESS = {
  CREATED: 'Leçon créée avec succès',
  UPDATED: 'Leçon mise à jour avec succès',
  DELETED: 'Leçon supprimée avec succès',
} as const

export const LESSON_OPERATIONS = {
  CREATE: 'create_lesson',
  FIND_ALL: 'findAll_lessons',
  FIND_ONE: 'findOne_lesson',
  UPDATE: 'update_lesson',
  DELETE: 'delete_lesson',
  RESTORE: 'restore_lesson',
} as const

export const LESSON_LOG_MESSAGES = {
  CREATING: (userId: string, title: string) =>
    `[User ${userId}] Création leçon: ${title}`,
  CREATED: (id: string) => `Lesson created successfully: ${id}`,
  UPDATING: (userId: string, id: string) =>
    `[User ${userId}] Mise à jour leçon: ${id}`,
  UPDATED: (id: string) => `Lesson updated successfully: ${id}`,
  DELETING: (userId: string, id: string) =>
    `[User ${userId}] Suppression leçon: ${id}`,
  DELETED: (id: string) => `Lesson deleted successfully: ${id}`,
  FOUND: (count: number) => `Found ${count} lessons`,
} as const

export const LESSON_ERROR_CONTEXTS = {
  CREATE: 'create lesson',
  FETCH_ALL: 'fetch lessons',
  FETCH_ONE: 'fetch lesson',
  UPDATE: 'update lesson',
  DELETE: 'delete lesson',
  RESTORE: 'restore lesson',
} as const

export const LESSON_POLICY_ACTIONS = {
  CREATE: 'lesson:create',
  VIEW: 'lesson:view',
  UPDATE: 'lesson:update',
  DELETE: 'lesson:delete',
} as const
